var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAiConnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.91 3.65001C5.89 3.60001 5.85 3.57001 5.8 3.57001H4.85C4.85 3.57001 4.76 3.60001 4.75 3.65001L2.69 10.08C2.67 10.14 2.7 10.2 2.76 10.22C2.77 10.22 2.78 10.22 2.79 10.22H3.37C3.37 10.22 3.46 10.19 3.47 10.14L3.79 9.11001L3.82 9.02001H6.83L6.86 9.11001L7.17 10.14C7.17 10.14 7.23 10.22 7.28 10.22H7.86C7.92 10.22 7.97 10.17 7.97 10.11C7.97 10.1 7.97 10.09 7.97 10.08L5.91 3.65001ZM6.4 8.25001H4.09L4.14 8.08001L5.2 4.77001L5.32 4.39001L5.44 4.77001L6.51 8.08001L6.56 8.25001H6.38H6.4Z",
    fill: "#373F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.57 3.96001C10.57 3.74462 10.3976 3.57001 10.185 3.57001C9.97237 3.57001 9.8 3.74462 9.8 3.96001V9.84001C9.8 10.0554 9.97237 10.23 10.185 10.23C10.3976 10.23 10.57 10.0554 10.57 9.84001V3.96001Z",
    fill: "#373F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.19 7.14V2.65C14.19 1.19 13 0 11.54 0H2.65C1.19 0 0 1.19 0 2.65V11.53C0 12.99 1.19 14.18 2.65 14.18H8.1C7.89 13.95 7.71 13.69 7.58 13.4H2.65C1.62 13.4 0.78 12.56 0.78 11.53V2.65C0.78 1.62 1.62 0.78 2.65 0.78H11.53C12.56 0.78 13.4 1.62 13.4 2.65V6.97C13.67 6.98 13.94 7.04 14.19 7.14Z",
    fill: "#373F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.29 13.59L16.85 12.98C16.94 12.95 16.98 12.85 16.95 12.76C16.93 12.72 16.9 12.68 16.85 12.66L15.29 12.05C14.73 11.83 14.29 11.39 14.07 10.83L13.46 9.28001C13.43 9.21001 13.37 9.17001 13.3 9.17001C13.23 9.17001 13.17 9.21001 13.14 9.28001L12.53 10.83C12.31 11.39 11.87 11.83 11.31 12.05L9.76 12.66C9.67 12.69 9.63 12.79 9.66 12.88C9.68 12.92 9.71 12.96 9.76 12.98L11.31 13.59C11.87 13.81 12.31 14.25 12.53 14.81L13.14 16.36C13.17 16.43 13.23 16.47 13.3 16.47C13.37 16.47 13.43 16.43 13.46 16.36L14.07 14.81C14.29 14.25 14.73 13.81 15.29 13.59Z",
    fill: "#373F41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.96,
    height: 16.46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiConnect);
export default __webpack_public_path__ + "static/media/IconAiConnect.d368331ae40e530ab64e2d362c246ce9.svg";
export { ForwardRef as ReactComponent };